import { Component, OnInit, Input, ViewChild, TemplateRef, ElementRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import { clientHistoryComponent } from '../../common/clientHistory';
import { PhClientModel, ClientWalkInModel } from '../../../model/index';
import { FollowUpClientUploadService, PhClientService, CommonService, SubscribeService } from '../../../services/index';
import * as fromCommonStore from '../../../store';
import * as fromRootStore from '../../../reducers';
import { Store } from '@ngrx/store';
import * as XLSX from 'xlsx';
import * as _ from 'lodash';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';
import * as moment from 'moment';

export interface User {
    name: string;
}
@Component({
    selector: 'follow-up-client-upload',
    templateUrl: './followUpClientUpload.component.html',
})
export class followUpClientUploadComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;
    @ViewChild('singleClientDetails') singleClientDetails;
    @ViewChild('fileUpload') fileUpload;
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;
    @ViewChild('clientDetail') clientDetail;
    loadingIndicator: boolean = true;
    reorderable: boolean = true;
    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'client_no',
        orderDir: 'asc'
    };

    isLoadMask: Promise<any>;
    // clientData: PhClientModel[];
    excelData: any;
    isLoading: boolean = false;
    filterData = {
        "search_data": ""
    };
    clientList = [];
    existClient: { 'client_id': number; 'fol_status': number; 'assignee_id': number; };
    clientFilter: Observable<string[]>;
    clientCtrl = new FormControl;
    customersList: any;
    statusList: any;
    assignToList: any;
    columns = [];
    scrollTimeout: any;
    suppressPaging: boolean = false;
    filteredItems: Observable<any[]>;
    private searchTerms = new Subject<string>();
    upload_type:any;

    constructor(public store: Store<fromRootStore.State>,
        private phClientService: PhClientService, private modalService: BsModalService, public toasterService: ToasterService, private commonService: CommonService,
        private followUpClientUploadService: FollowUpClientUploadService, public subscribeService: SubscribeService) {
        this.assignToList = [];
        this.customersList = [];
    }

    ngOnInit(): void {
        this.initExistingDetail();
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 70, minWidth: 70, maxWidth: 70, cellClass: 'cell-center', sortable: false, cellTemplate: this.snoTemplate },
            { name: 'Client ID', prop: 'client_no', width: 120, minWidth: 120, maxWidth: 120 },
            { name: 'Name', prop: 'client_name', width: 150, minWidth: 150, maxWidth: 150 },
            { name: 'Address', prop: 'address', width: 245, minWidth: 245, maxWidth: 245 },
            { name: 'Mobile', prop: 'disp_mobile', width: 120, minWidth: 120, maxWidth: 120 },
            { name: 'Reference', prop: 'reference_name', width: 150, minWidth: 150, maxWidth: 150 },
            { name: 'Reg. Branch', prop: 'branch_name', width: 120, minWidth: 120, maxWidth: 120 },
            { name: 'Action', prop: 'sno', width: 180, minWidth: 180, maxWidth: 180, sortable: false, cellTemplate: this.editDeleteTemplate }
        ];

        this.pageCallback({ offset: 0 });
    }

    /**
    * Called whenever the user changes page
    */
    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {

        this.page.offset = pageInfo.offset;

    }

    onScroll() {
        this.suppressPaging = true;
        if (this.scrollTimeout) {
            //celarTimeout(this.scrollTimeout);
        }
        this.scrollTimeout = setTimeout(() => {
            this.suppressPaging = false;
        }, 100)
    }

    openWindow() {
        this.fileUpload.click();
    }

    downloadFile() {
        let link = document.createElement("a");
        link.download = "assets/sampleExcel/followUpClientUploadSample.xlsx";
        link.href = "assets/sampleExcel/followUpClientUploadSample.xlsx";
        link.click();
    }

    onOpenedFilter(): void {
        setTimeout(function () {
            $('#filterSearch').focus();
        }, 100);

    }
    clearFilter(): void {
        this.filterData = {
            "search_data": ""
        };
        this.applyFilter();
    }
    uploadFile(sheet) {
        console.log(sheet);
        let workBook = null;
        let jsonData = null;
        const reader = new FileReader();
        if ((sheet.target.files.length == 0) || (sheet.target.files.length < 0)) {
            return;
        }
        const file = sheet.target.files[0];
        reader.onload = (event) => {
            var checkFlag = true;
            const data = reader.result;
            workBook = XLSX.read(data, { type: 'binary', cellDates: true });
            jsonData = workBook.SheetNames.reduce((initial, name) => {
                const sheet = workBook.Sheets[name];
                initial[name] = XLSX.utils.sheet_to_json(sheet);
                return initial;
            }, {});
            if (Object.keys(jsonData).length == 1) {
                for (var j = 0; j < jsonData.Sheet1.length; j++) {
                    // jsonData.Sheet1[j].un_id = j;
                    // TO CONVERT DATE STRING FROM EXCEL
                    if (jsonData.Sheet1[j].DATE && typeof jsonData.Sheet1[j].DATE === "object") {
                        jsonData.Sheet1[j].CONV_DATE = moment(jsonData.Sheet1[j].DATE).format('DD.MM.YYYY');
                        // var isDate = _.isDate(jsonData.Sheet1[j].DATE);
                        // if(isDate) {
                        //     jsonData.Sheet1[j].CONV_DATE = moment(jsonData.Sheet1[j].DATE).format('DD.MM.YYYY');
                        // } else {
                        //     swal({ 
                        //         title: `Please Check DATE in Line Number ${j + 1}`
                        //     });
                        //     checkFlag = false;
                        //     break;
                        // }
                    } else {
                        jsonData.Sheet1[j].CONV_DATE = jsonData.Sheet1[j].DATE;
                    }
                    for (var k = 1; k <= 5; k++) {
                        var dateName = 'T' + k + ' DATE';
                        var convDateName = 'CONV_' + dateName;
                        if (jsonData.Sheet1[j][dateName] && typeof jsonData.Sheet1[j].DATE === "object") {
                            // var isDesDate = _.isDate(jsonData.Sheet1[j][dateName]);
                            // if(isDesDate) {
                            jsonData.Sheet1[j][convDateName] = moment(jsonData.Sheet1[j][dateName]).format('DD.MM.YYYY');
                            // } else {
                            //     swal({ 
                            //         title: `Please Check ${dateName} in Line Number ${j + 1}`
                            //     });
                            //     checkFlag = false;
                            //     break;
                            // }
                        } else {
                            jsonData.Sheet1[j][convDateName] = jsonData.Sheet1[j][dateName];
                        }
                    }
                }
                if (checkFlag) {
                    this.excelData = JSON.stringify(jsonData);
                    this.clientList = jsonData.Sheet1;
                    console.log(this.clientList);
                }
            }
            else {
                this.excelData = '';
                sheet.srcElement.value = null;
                let toast = {
                    type: 'error',
                    title: 'ERROR',
                    body: 'PLEASE UPLOAD THE FILE WITH ONLY ONE SHEET'
                };
                this.toasterService.pop(toast);
            }
        }
        reader.readAsBinaryString(file);
        // TO CLEAR FILE FROM INPUT TYPE
        this.fileUpload.nativeElement.value = "";
    }
    saveFile() {
        const that = this;
        let params = {
            data: this.excelData,
            uploadType:this.upload_type
        };
        this.isLoadMask = this.followUpClientUploadService
            .saveExcelFile(params)
            .then(function (res: any) {
                if (res.success) {
                    that.excelData = [];
                    that.clientList = [];
                    swal(res.message);
                    that.subscribeService.subScribeDeleteActiveTab();                    
                } else {
                    swal({
                        title: res.message,
                        text: res.subMessage
                    });
                }

            });

    }
    applyFilter(): void {
        //this.filterExpand = false;
        this.filterPanel.close();
    }
    onChangePageSize(limit) {
        this.page.limit = limit;
    }
    /* bsModalRef: BsModalRef;
     public addBrandmodel(): void {
         this.bsModalRef = this.modalService.show(AddEditBrandmodelComponent, {
             keyboard: false,
             ignoreBackdropClick: true
         });

         this.bsModalRef.content.title = 'Add BRAND MODEL Details';
         this.bsModalRef.content.mode = 'Add';
         this.bsModalRef.content.brandmodeldata = {};
     }*/
    bsModalRef: BsModalRef;
    onAddEditClient(mode: string, row: any): void {
        let that = this,
            clientPhoto = [];
        setTimeout(function () {
            that.filterPanel.close();
        }, 10);
        if (mode == "Add") {
            row = {
                'ref_id': ''
            }
        } else if (mode == 'Edit') {
            if (row['dob'] != '0000-00-00') {
                row['dob'] = new Date(row['dob']);
            }
            if (row['client_photo'] != '') {
                clientPhoto.push('assets/client/' + row['client_photo']);
            }
        }
        // row['mode'] = mode;
        // this.bsModalRef.content.title = mode + ' PH Client Details';
        // //this.bsModalRef.content.mode = mode;
        // this.bsModalRef.content.clientdata = Object.assign({}, row);
        // this.bsModalRef.content.clientPhoto = clientPhoto;
        // this.bsModalRef.content.clientUpdateEvent.subscribe(($e) => {
        //     that.getClientList();
        // });
    }
    // onEditClient(row: any): void {
    //
    //     this.bsModalRef = this.modalService.show(AddEditClientComponent, {
    //         keyboard: false,
    //         ignoreBackdropClick: true
    //     });
    //     this.bsModalRef.content.clientdata = Object.assign({}, row);
    //     this.bsModalRef.content.title = 'Edit CLIENT  Details';
    //     this.bsModalRef.content.mode = 'Edit';
    //     this.bsModalRef.content.clientdata = row;
    //
    // }


    /* onEditBrandmodel(mode: string, row: any): void {
         //this.filterPanel.close();
         let that = this;
         if (mode == "Edit") {
             row = {
                 'brand_id': ''
             }
         }
         this.bsModalRef = this.modalService.show(AddEditBrandmodelComponent, {
             keyboard: false,
             ignoreBackdropClick: true
         });
         this.bsModalRef.content.title = mode + 'EDIT BRAND MODEL Details';
         this.bsModalRef.content.mode = mode;
         this.bsModalRef.content.brandmodeldata = Object.assign({}, row);
         this.bsModalRef.content.brandUpdateEvent.subscribe(($e) => {
             that.getBrandmodelList();
         });
     }*/
    fileData() {
        if (!this.excelData) {
            return true
        }
    }
    onDeleteClient(row: any): void {
        let that = this,
            msgTitle = 'Error',
            msgType = 'error',
            data = {
                client_id: row.client_id
            };
        swal({
            title: 'Are you sure to Delete?',
            text: 'You will not be able to Recover Client No: ' + row.client_no + ' Again!',
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'No, Keep it'
        }).then(function () {
            that.isLoadMask = that.phClientService
                .deleteClient(row.client_id)
                .then(function (res: any) {
                    if (res.success) {
                        swal(
                            'Deleted',
                            res.message,
                            'success'
                        );
                    } else {
                        swal(
                            'ERROR',
                            res.message,
                            'error'
                        );
                    }
                });

        }, function (dismiss) {

        });
    }
    viewHistory(row) {
        let data = {
            client_id: row.client_id,
            from_page: 'followUp'
        }
        /*         that=this;
                that.commonService
                    .getClientHistory(data)
                    .then(function (res: any) {
                        that.clientdata=res.data;
                    }); */
        this.bsModalRef = this.modalService.show(clientHistoryComponent, {
            keyboard: false,
            //ignoreBackdropClick: false,
            class: 'modal-lg maxWidthPer-80 clienthistorywidth'
        });
        this.bsModalRef.content.showClientHistory = data;
    }




    // Existing Client tab

    customerOption: Observable<User[]>;
    followupOptions: Observable<User[]>;
    assignOptions: Observable<User[]>;

    followupCtrl = new FormControl;
    assigneeCtrl = new FormControl;
    async initExistingDetail() {
        let that = this;
        this.existClient = {
            'client_id': 0,
            'fol_status': 0,
            'assignee_id': 0
        };
        this.store.select(fromCommonStore.getAllFollowUpStatus).subscribe((res: any) => {
            if (_.isEmpty(res.data)) {
                return;
            }
            this.statusList = res.data.filter(e => e.is_followup == 'Yes' && e.is_working_followup == 'Yes');
        });
        // this.customerOption = 
        // this.clientCtrl.valueChanges	
        //     .startWith('')	
        //     .map(name => name ? this.searchTerms.next(name) : '');	
        this.followupOptions = this.followupCtrl.valueChanges
            .startWith('')
            .map(name => name ? this.filterFollowup(name) : this.statusList.slice());
        this.assignOptions = this.assigneeCtrl.valueChanges
            .startWith('')
            .map(name => name ? this.filterFollower(name) : this.assignToList.slice());

        this.filteredItems = this.searchTerms
            .debounceTime(300)        // wait 300ms after each keystroke before considering the term
            .distinctUntilChanged()   // ignore if next search term is same as previous
            .switchMap(term => term   // switch to new observable each time the term changes
                // return the http search observable
                ? this.commonService.loadClientList(term, 'walkIn')
                // or the observable of empty heroes if there was no search term
                : Observable.of<ClientWalkInModel[]>([]))
            .catch(error => {
                // TODO: add real error handling
                console.log(error);
                return Observable.of<ClientWalkInModel[]>([]);
            });

        this.filteredItems.subscribe(($e) => {
            that.clientList = $e;
        });
    }


    // async loadClientList(search) {
    //     let that = this
    //     let params = {
    //         search: search
    //     }
    //     await this.commonService.getClientList(params)
    //         .then(function (res: any) {
    //             that.customersList = res.data;
    //         });
    // }

    displayRef(item_id: number) {
        if (item_id && this.clientList.length > 0) {
            let fitem: any = _.find(this.clientList, { 'client_id': item_id }),
                ref_name = (fitem.client_no) ? fitem.client_no : '';
            this.getUserDetails(fitem);
            // this.existClient.client_id = fitem.client_id;
            return ref_name;
        }
        return '';
    }

    // filterHa(name: string) {	
    //     // this.loadClientList(name);	
    //     name = _.escapeRegExp(name);	
    //     return this.customersList.filter(ha => (new RegExp(name, 'gi').test(ha.client_no)	
    //         || new RegExp(name, 'gi').test(ha.client_name)));	
    // }	
    filterFollowup(name: string) {
        this.assignToList = [];
        name = _.escapeRegExp(name);
        return this.statusList.filter(ha => (new RegExp(name, 'gi').test(ha.name)));
    }
    filterFollower(name: string) {
        name = _.escapeRegExp(name);
        return this.assignToList.filter(ha => (new RegExp(name, 'gi').test(ha.fullname)));
    }
    getUserDetails(data) {
        if (data) {
            this.singleClientDetails.loadClient(data);
        }
    }

    displayStatusFn(fol_id: any) {
        let that = this;
        that.existClient.assignee_id = 0;
        
        if (this.statusList != undefined) {
            if (fol_id && this.statusList.length > 0) {
                let folObj = _.find(this.statusList, { 'fol_id': fol_id });
                // TO LOAD ASSIGNEE DROPDOWN VALUES
                if (fol_id) {
                    let data = {
                        fol_id: fol_id
                    };
        
                    that.commonService
                        .getUserList(data)
                        .then(function (res: any) {
                            that.assignToList = res.data;
                            // that.assigneeCtrl.setValue(that._params['act_assign_empid']);
                        });
                }

                return folObj['name'];
            }
        }
        return '';
    }
    assignFn(empid: any) {
        if (this.assignToList != undefined) {
            if (empid && this.assignToList.length > 0) {
                let fitem = _.find(this.assignToList, { 'userid': empid });
                return fitem['fullname'];
            }
        }
        return '';
    }

    validate() {
        let flag = false;
        if (this.existClient.assignee_id && this.existClient.fol_status && this.existClient.client_id) {
            flag = false;
        } else {
            flag = true;
        }
        return flag;
    }

    saveDetail() {
        let that = this;
        this.followUpClientUploadService.changeExistingClientFollowup(this.existClient).then(res => {
            if (res.success) {
                swal("SUCCESS", res.message, 'success');
                that.initExistingDetail();
                that.subscribeService.subScribeDeleteActiveTab();
            } else {
                swal("ERROR", res.message, 'error');
            }
        });
    }

}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/followUpClientUpload/followUpClientUpload.component.ts